<template>
    <v-container fluid>
        <!--name-->
        <v-row class="my-2 subtitle-2 secondary--text pl-12">
            Institutes 
        </v-row>
        <v-container>
            <add-institute />
        </v-container>
        <div v-if="institutes?.length > 0">
            <!--itstitutes table head-->
            <v-row class="subtitle-2 px-6 font-weight-bold mb-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <v-expansion-panels focusable>
                <v-expansion-panel v-for="institute in institutes" :key="institute.id">
                    <v-expansion-panel-header>
                        <!-- tab row-->
                        <v-row class="body-2" no-gutters>
                            <v-col class="text-left">{{ institute.country }}</v-col>
                            <v-col class="text-center">{{ institute.city }}</v-col>
                            <v-col class="text-center">{{ institute.name }}</v-col>
                            <v-col class="text-center">{{ institute.faculty }}</v-col>
                            <v-col class="text-center">{{ institute.contract }}</v-col>
                            <v-col class="text-center">{{ localeNum(institute.price) }}</v-col>
                            <v-col class="text-center">{{ dateToString(institute.date_expired) }}</v-col>   
                            <v-col class="text-center">
                                <add-promo :institute="institute" />
                                <delete-institute :institute="institute" />
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="body-2">
                        <!--- codes -->
                        <v-row class="subtitle-2 font-weight-bold" no-gutters>
                            <v-col v-for="(header, idx) in headers2" :key="idx" class="text-left">
                                {{ header }}
                            </v-col>
                        </v-row>
                        <v-divider class="my-1"></v-divider>
                        <v-row v-for="code in institute.codes" :key="code.id" no-gutters>
                            <v-col class="text-left">{{ code.code }}</v-col>
                            <v-col class="text-left">{{ code.user_name }}</v-col>
                            <v-col class="text-left">{{ code.status }}</v-col>
                            <v-col class="text-left">
                                <delete-code :promo="code"></delete-code>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

        </div>
        <v-row v-else class="mt-8 px-4">
            You haven't institutes yet!
        </v-row>  
    </v-container>
</template>
<script>
import AddInstitute from '../../../components/admin/institutes/addInstitute';
import AddPromo from '../../../components/admin/institutes/addPromo.vue';
import DeleteInstitute from '../../../components/admin/institutes/deleteInstitute.vue';
import DeleteCode from '../../../components/admin/institutes/deletePromo.vue'

import { localeNumber } from '../../../functions/common';
export default {
    name: 'Institutes',
    data() {
        return {
            headers: [
                { title: 'country', style: 'text-left' },
                { title: 'city', style: 'text-center' },
                { title: 'institute', style: 'text-center' },
                { title: 'faculty', style: 'text-center' },
                { title: 'contract', style: 'text-center' },
                { title: 'price (MDL)', style: 'text-center' },
                { title: 'date expiration', style: 'text-center' },
                { title: 'action', style: 'text-center' },
            ],
            headers2: ['institute codes:', 'professor name', 'status', 'action']
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        institutes() {
            console.log(this.$store.getters.institutes)
            return this.$store.getters.institutes;
        },

    },
    methods: {
        dateToString(date) {
            return date.toLocaleString('en-GB', { timeZone: 'UTC' }).substr(0, 10);
        },
        selializing(arr) {
            const codes = arr.map(item => item.code)
            return codes.join(', ');
        },
        localeNum(param) {
            return localeNumber(param, this.locale);
        }
    },
    components: {AddInstitute, AddPromo, DeleteCode, DeleteInstitute},
    async mounted() {

        if (this.institutes.length < 1) {
            try {
                await this.$store.dispatch('fetchInstitutes')
            }
            catch (error) {
                console.log(error.message);
            }
        }
    }
}
</script>